module.exports = __webpack_public_path__ + "img/weixin.c084c3e8.png";